import { render, staticRenderFns } from "./FeatureListTemplate.vue?vue&type=template&id=68392554&scoped=true&"
import script from "./FeatureListTemplate.vue?vue&type=script&lang=js&"
export * from "./FeatureListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68392554",
  null
  
)

export default component.exports